import React from 'react'
import AppBar from 'material-ui/AppBar';

const Intro = () => {
  return (
      <div>
    <h2>Why do we need this app?</h2>
    <p>We know that flash is going away and not going to be supported by Chrome by 2020.</p>
    <p>However, there are is a lot of flash content out there that educators are still using and need a temporary solution to play their content.</p>
    <p>This app is only intended to provide a temporary solution until the content providers update their content to the latest web standards.</p>
    <p>You can read more about Google's future plans on Flash here: <a href="https://www.blog.google/products/chrome/saying-goodbye-flash-chrome/">Saying Goodbye to Flash in Chrome.</a></p>
    </div>
  )
}

export default Intro


// WEBPACK FOOTER //
// ./src/Intro.js